import React, { useState } from 'react';
import * as S from './styles';
import CloseIcon from '@mui/icons-material/Close';
import { SubmitButton } from 'components/Buttons/SubmitButton';
import { CheckBoxOutlined } from '@mui/icons-material';
import alertBlue from '../../assets/image/blueAlertEmoji.svg';

const ActivationModal = ({
  isOpen,
  onClose,
  onConfirm,
  cancelError,
  alertType,
  setAlertType,
  isLoading,
}) => {

  if (!isOpen) {
    return null;
  }

  const handleConfirm = () => {
    onConfirm();
  };

  const ConfirmActivationAgent = ({ onClick, alertType, setAlertType }) => {
    return (
      <SubmitButton
        isLoading={isLoading}
        onClick={onClick}
        alertType={alertType}
        setAlertType={setAlertType}
        buttonText="Ativar Agente"
        successMsg="Sucesso ao ativar Agente."
        errorMsg="Erro ao ativar o agente."
        startIcon={<CheckBoxOutlined />}
        sx={{ width: "260px" }}
      />
    );
  };

  return (
    <S.ModalOverlay>
      <S.ModalContent>
        <S.CloseButton onClick={onClose}>
          <CloseIcon />
        </S.CloseButton>
        <S.ModalHeader>
          <S.Emoji src={alertBlue} alt="Emoji de alerta azul"></S.Emoji>
          <S.ModalTitle>Tem certeza que deseja Ativar o Agente?</S.ModalTitle>
        </S.ModalHeader>
        <S.ModalBody>
          <S.JustificationText>O Agente será ativado.</S.JustificationText>
        </S.ModalBody>
        <S.ModalFooter>
          <ConfirmActivationAgent
            onClick={handleConfirm}
            alertType={alertType}
            setAlertType={setAlertType}
          />
        </S.ModalFooter>
      </S.ModalContent>
    </S.ModalOverlay>
  );
};

export default ActivationModal;
